import { Button, Typography } from "antd";
import CardWithBrandLogo from "components/ui/CardWithBrandLogo";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "./RegisterFailed.module.scss";

const RegisterFailed: React.FC = () => {
  const { t } = useTranslation();

  return (
    <CardWithBrandLogo
      footerContent={
        <Link to="/login">
          <Button type="link" className={styles.button}>
            {t("register.backToLogin")}
          </Button>
        </Link>
      }
    >
      <div>
        <Typography.Title>{t("register.failed.title")}</Typography.Title>

        <div className={styles.description}>
          {t("register.failed.description")}
        </div>
      </div>
    </CardWithBrandLogo>
  );
};

export default RegisterFailed;
